import Repository from '../Repository'

export default {
  getHolidays: (year) => {
    return Repository.get('holidays/active-days/' + year)
  },
  toggleHoliday: (params) => {
    return Repository.patch('holidays/toggle', params)
  },
  isActiveHoliday: (date) => {
    return Repository.get('holidays/active-day/' + date)
  }
}
